export const endpoint = {
  user: 'user',
  role: 'role',
  userAccess: 'user/access',
  userRoleAllOptions: 'user/role/all/options',
  roleAccess: 'role/access',
  roleSearch: 'role/search'
};
